import React from 'react';
import ReportingClassesPage from '../components/ReportingClassesPage';

const ReportingClassesApp = (props) => (
  <ReportingClassesPage {...props} />
);

export default ReportingClassesApp;
